<template>
    <div class="upcoming-events-card">
        <div class="upcoming-events-card-tags">
            <div class="event-card-tags-text upcoming-events-card-tags-content"
                 :style="colorStyle"
            >
                {{ categories_str }}
            </div>
        </div>
        <div class="upcoming-events-card-title event-card-title-text">
            {{ description }}
        </div>
        <div class="upcoming-events-card-place">
            <img
                class="upcoming-events-card-place-img"
                :src="eventImg"
                height="45"
                width="45"
            />
            <div class="upcoming-events-card-place-text event-card-title-text">
                {{ upcomingEvent.location }}
            </div>
            <div class="upcoming-events-card-place-btn" v-if="upcomingEvent.news_id">
                <v-btn
                    width="30"
                    min-width="30"
                    height="30"
                    rounded="xl"
                    @click="moveToNews(upcomingEvent.news_id)">
                    <svg-icon :svgData="btnSvg"/>
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import SvgIcon from '@/components/content/SvgIcon.vue';
import { useEventsStore } from '@/store/events'

export default {
    name: 'UpcomingEventsCard',
    components: {
        SvgIcon
    },
    props: {
        upcomingEvent: Object
    },
    data() {
        return {
            btnSvg: {
                    width: "7",
                    height: "11",
                    viewBox: "0 0 7 11",
                    pathArr: [{
                        d: "M0.157032 9.23076L1.33203 10.4058L6.33203 5.40576L1.33203 0.405762L0.157032 1.58076L3.9737 5.40576L0.157032 9.23076Z",
                        fill: "#0635AC"
                }]
            }
        }
    },
    computed:{
        categories_str(){
            let str = ''
            for (let filter of this.upcomingEvent.filers){
                if (str!='')
                    str += ' '
                str += '#' + filter.name
            }
            return str
        },
        colorStyle(){
            let eventsStore = useEventsStore()
            let color = eventsStore.getEventColor(this.upcomingEvent)
            if (this.upcomingEvent.color === null)
                return 'background-color: #3B66D3;'
            return 'background-color: ' + color
        },
        description(){
            if (this.upcomingEvent.description){
                return this.upcomingEvent.description
            }
            return 'Описание отсутствует'
        },
        eventImg(){
            if (this.upcomingEvent.image)
                return document.location.origin + '/' + this.upcomingEvent.image
            return '/img/empty_img.webp'
        }
    },
    // async mounted(){
        
    // }
    methods: {
        moveToNews(news_id){
            this.$router.push({'name':'NewsPage', "params": {id: news_id}})
        }
    }
}
</script>